<div class="row">
  <div class="col-sm-12">
    <app-card [title]="'doctrine.dealer.multipliers'|translate">
      <form class="" #countryForm="ngForm" action="javascript:">
        <div class="form-row row">
          <div class="form-group col-md-3" *ngFor="let dealerType of dealerTypes; let i = index;">
            <label for="multiplier-{{i}}">{{dealerType.name | translate}} {{"doctrine.dealer.multiplier" | translate}}</label>
            <span class="star">*</span>
            <input required name="multiplier-{{i}}"
                   #multiplier="ngModel"
                   id="multiplier-{{i}}"
                   class="form-control"
                   [(ngModel)]="dealerType.multiplier">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="multiplier.invalid && multiplier.dirty && multiplier.errors?.required">{{'errors.required'|translate}}
            </div>
          </div>
        </div>
        <div class="text-end">
          <button (click)="backToDashboard()" class="btn btn-link" type="button">{{'global.cancel'|translate}}</button>
          <button type="button" class="btn btn-primary ripple light" [disabled]="!countryForm.valid" (click)="saveDealerTypes()">
            {{'global.actions.save'|translate}}
          </button>
        </div>
      </form>
    </app-card>
  </div>
</div>
